var React = require('react');

function Menu1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"menu1"),React.createElement("path",{"d":"M0 3h20v2h-20v-2zM0 9h20v2h-20v-2zM0 15h20v2h-20v-2z","key":1})]);
}

Menu1.defaultProps = {"version":"1.1","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Menu1;

Menu1.default = Menu1;
